import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';
import styled from 'styled-components';

export const FooterPattern = ({ color, size, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
    >
      <pattern
        id="pattern-footer"
        x="0"
        y="0"
        width="1440"
        height="255"
        patternUnits="userSpaceOnUse"
      >
        <LineLg>
          <line className="line_lg" x1="10" y1="21.84" x2="10" y2="255" />
          <line className="line_lg" x1="30" y1="24.25" x2="30" y2="255" />
          <line className="line_lg" x1="50" y1="26.95" x2="50" y2="255" />
          <line className="line_lg" x1="70" y1="28.89" x2="70" y2="255" />
          <line className="line_lg" x1="90" y1="31.02" x2="90" y2="255" />
          <line className="line_lg" x1="110" y1="33.28" x2="110" y2="255" />
          <line className="line_lg" x1="130" y1="35.63" x2="130" y2="255" />
          <line className="line_lg" x1="150" y1="38.01" x2="150" y2="255" />
          <line className="line_lg" x1="170" y1="39.39" x2="170" y2="255" />
          <line className="line_lg" x1="190" y1="40.74" x2="190" y2="255" />
          <line className="line_lg" x1="210" y1="43.01" x2="210" y2="255" />
          <line className="line_lg" x1="230" y1="45.2" x2="230" y2="255" />
          <line className="line_lg" x1="250" y1="47.27" x2="250" y2="255" />
          <line className="line_lg" x1="270" y1="49.21" x2="270" y2="255" />
          <line className="line_lg" x1="290" y1="51.02" x2="290" y2="255" />
          <line className="line_lg" x1="310" y1="52.68" x2="310" y2="255" />
          <line className="line_lg" x1="330" y1="54.19" x2="330" y2="255" />
          <line className="line_lg" x1="350" y1="55.55" x2="350" y2="255" />
          <line className="line_lg" x1="370" y1="56.76" x2="370" y2="255" />
          <line className="line_lg" x1="390" y1="57.82" x2="390" y2="255" />
          <line className="line_lg" x1="410" y1="58.73" x2="410" y2="255" />
          <line className="line_lg" x1="430" y1="59.49" x2="430" y2="255" />
          <line className="line_lg" x1="450" y1="60.1" x2="450" y2="255" />
          <line className="line_lg" x1="470" y1="60.58" x2="470" y2="255" />
          <line className="line_lg" x1="490" y1="60.92" x2="490" y2="255" />
          <line className="line_lg" x1="510" y1="61.13" x2="510" y2="255" />
          <line className="line_lg" x1="530" y1="61.2" x2="530" y2="255" />
          <line className="line_lg" x1="550" y1="61.11" x2="550" y2="255" />
          <line className="line_lg" x1="570" y1="60.82" x2="570" y2="255" />
          <line className="line_lg" x1="590" y1="60.34" x2="590" y2="255" />
          <line className="line_lg" x1="610" y1="59.65" x2="610" y2="255" />
          <line className="line_lg" x1="630" y1="58.8" x2="630" y2="255" />
          <line className="line_lg" x1="650" y1="57.79" x2="650" y2="255" />
          <line className="line_lg" x1="670" y1="56.62" x2="670" y2="255" />
          <line className="line_lg" x1="690" y1="55.32" x2="690" y2="255" />
          <line className="line_lg" x1="710" y1="53.9" x2="710" y2="255" />
          <line className="line_lg" x1="730" y1="52.37" x2="730" y2="255" />
          <line className="line_lg" x1="750" y1="50.74" x2="750" y2="255" />
          <line className="line_lg" x1="770" y1="49.03" x2="770" y2="255" />
          <line className="line_lg" x1="790" y1="47.25" x2="790" y2="255" />
          <line className="line_lg" x1="810" y1="45.41" x2="810" y2="255" />
          <line className="line_lg" x1="830" y1="43.52" x2="830" y2="255" />
          <line className="line_lg" x1="850" y1="41.6" x2="850" y2="255" />
          <line className="line_lg" x1="870" y1="39.66" x2="870" y2="255" />
          <line className="line_lg" x1="890" y1="37.71" x2="890" y2="255" />
          <line className="line_lg" x1="910" y1="35.76" x2="910" y2="255" />
          <line className="line_lg" x1="930" y1="33.83" x2="930" y2="255" />
          <line className="line_lg" x1="950" y1="31.91" x2="950" y2="255" />
          <line className="line_lg" x1="970" y1="30.03" x2="970" y2="255" />
          <line className="line_lg" x1="990" y1="28.19" x2="990" y2="255" />
          <line className="line_lg" x1="1010" y1="26.4" x2="1010" y2="255" />
          <line className="line_lg" x1="1030" y1="24.68" x2="1030" y2="255" />
          <line className="line_lg" x1="1050" y1="23.02" x2="1050" y2="255" />
          <line className="line_lg" x1="1070" y1="21.44" x2="1070" y2="255" />
          <line className="line_lg" x1="1090" y1="19.94" x2="1090" y2="255" />
          <line className="line_lg" x1="1110" y1="18.52" x2="1110" y2="255" />
          <line className="line_lg" x1="1130" y1="17.21" x2="1130" y2="255" />
          <line className="line_lg" x1="1150" y1="15.99" x2="1150" y2="255" />
          <line className="line_lg" x1="1170" y1="14.89" x2="1170" y2="255" />
          <line className="line_lg" x1="1190" y1="13.89" x2="1190" y2="255" />
          <line className="line_lg" x1="1210" y1="13.01" x2="1210" y2="255" />
          <line className="line_lg" x1="1230" y1="12.26" x2="1230" y2="255" />
          <line className="line_lg" x1="1250" y1="11.62" x2="1250" y2="255" />
          <line className="line_lg" x1="1270" y1="11.12" x2="1270" y2="255" />
          <line className="line_lg" x1="1290" y1="10.74" x2="1290" y2="255" />
          <line className="line_lg" x1="1310" y1="10.5" x2="1310" y2="255" />
          <line className="line_lg" x1="1330" y1="10.4" x2="1330" y2="255" />
          <line className="line_lg" x1="1350" y1="10.45" x2="1350" y2="255" />
          <line className="line_lg" x1="1370" y1="10.72" x2="1370" y2="255" />
          <line className="line_lg" x1="1390" y1="12.18" x2="1390" y2="255" />
          <line className="line_lg" x1="1410" y1="14.9" x2="1410" y2="255" />
          <line className="line_lg" x1="1430" y1="17.85" x2="1430" y2="255" />
        </LineLg>
        <LineSm>
          <line className="line_sm" x1="10" y1="143.07" x2="10" y2="255" />
          <line className="line_sm" x1="30" y1="142.17" x2="30" y2="255" />
          <line className="line_sm" x1="50" y1="140.26" x2="50" y2="255" />
          <line className="line_sm" x1="70" y1="139.34" x2="70" y2="255" />
          <line className="line_sm" x1="90" y1="138.39" x2="90" y2="255" />
          <line className="line_sm" x1="110" y1="137.43" x2="110" y2="255" />
          <line className="line_sm" x1="130" y1="137.44" x2="130" y2="255" />
          <line className="line_sm" x1="150" y1="137.5" x2="150" y2="255" />
          <line className="line_sm" x1="170" y1="137.64" x2="170" y2="255" />
          <line className="line_sm" x1="190" y1="137.89" x2="190" y2="255" />
          <line className="line_sm" x1="210" y1="138.23" x2="210" y2="255" />
          <line className="line_sm" x1="230" y1="138.65" x2="230" y2="255" />
          <line className="line_sm" x1="250" y1="139.18" x2="250" y2="255" />
          <line className="line_sm" x1="270" y1="139.78" x2="270" y2="255" />
          <line className="line_sm" x1="290" y1="140.48" x2="290" y2="255" />
          <line className="line_sm" x1="310" y1="141.25" x2="310" y2="255" />
          <line className="line_sm" x1="330" y1="142.1" x2="330" y2="255" />
          <line className="line_sm" x1="350" y1="143.02" x2="350" y2="255" />
          <line className="line_sm" x1="370" y1="144.02" x2="370" y2="255" />
          <line className="line_sm" x1="390" y1="145.07" x2="390" y2="255" />
          <line className="line_sm" x1="410" y1="146.19" x2="410" y2="255" />
          <line className="line_sm" x1="430" y1="147.37" x2="430" y2="255" />
          <line className="line_sm" x1="450" y1="148.6" x2="450" y2="255" />
          <line className="line_sm" x1="470" y1="149.86" x2="470" y2="255" />
          <line className="line_sm" x1="490" y1="151.17" x2="490" y2="255" />
          <line className="line_sm" x1="510" y1="152.51" x2="510" y2="255" />
          <line className="line_sm" x1="530" y1="153.88" x2="530" y2="255" />
          <line className="line_sm" x1="550" y1="155.26" x2="550" y2="255" />
          <line className="line_sm" x1="570" y1="156.66" x2="570" y2="255" />
          <line className="line_sm" x1="590" y1="158.06" x2="590" y2="255" />
          <line className="line_sm" x1="610" y1="159.45" x2="610" y2="255" />
          <line className="line_sm" x1="630" y1="160.83" x2="630" y2="255" />
          <line className="line_sm" x1="650" y1="162.19" x2="650" y2="255" />
          <line className="line_sm" x1="670" y1="163.52" x2="670" y2="255" />
          <line className="line_sm" x1="690" y1="164.81" x2="690" y2="255" />
          <line className="line_sm" x1="710" y1="166.05" x2="710" y2="255" />
          <line className="line_sm" x1="730" y1="167.23" x2="730" y2="255" />
          <line className="line_sm" x1="750" y1="168.35" x2="750" y2="255" />
          <line className="line_sm" x1="770" y1="169.39" x2="770" y2="255" />
          <line className="line_sm" x1="790" y1="170.34" x2="790" y2="255" />
          <line className="line_sm" x1="810" y1="171.2" x2="810" y2="255" />
          <line className="line_sm" x1="830" y1="171.96" x2="830" y2="255" />
          <line className="line_sm" x1="850" y1="172.6" x2="850" y2="255" />
          <line className="line_sm" x1="870" y1="173.12" x2="870" y2="255" />
          <line className="line_sm" x1="890" y1="173.51" x2="890" y2="255" />
          <line className="line_sm" x1="910" y1="173.76" x2="910" y2="255" />
          <line className="line_sm" x1="930" y1="173.86" x2="930" y2="255" />
          <line className="line_sm" x1="950" y1="173.83" x2="950" y2="255" />
          <line className="line_sm" x1="970" y1="173.7" x2="970" y2="255" />
          <line className="line_sm" x1="990" y1="173.46" x2="990" y2="255" />
          <line className="line_sm" x1="1010" y1="173.12" x2="1010" y2="255" />
          <line className="line_sm" x1="1030" y1="172.67" x2="1030" y2="255" />
          <line className="line_sm" x1="1050" y1="172.11" x2="1050" y2="255" />
          <line className="line_sm" x1="1070" y1="171.43" x2="1070" y2="255" />
          <line className="line_sm" x1="1090" y1="170.64" x2="1090" y2="255" />
          <line className="line_sm" x1="1110" y1="169.73" x2="1110" y2="255" />
          <line className="line_sm" x1="1130" y1="168.7" x2="1130" y2="255" />
          <line className="line_sm" x1="1150" y1="167.55" x2="1150" y2="255" />
          <line className="line_sm" x1="1170" y1="166.29" x2="1170" y2="255" />
          <line className="line_sm" x1="1190" y1="164.91" x2="1190" y2="255" />
          <line className="line_sm" x1="1210" y1="163.43" x2="1210" y2="255" />
          <line className="line_sm" x1="1230" y1="161.84" x2="1230" y2="255" />
          <line className="line_sm" x1="1250" y1="160.16" x2="1250" y2="255" />
          <line className="line_sm" x1="1270" y1="158.41" x2="1270" y2="255" />
          <line className="line_sm" x1="1290" y1="156.6" x2="1290" y2="255" />
          <line className="line_sm" x1="1310" y1="154.75" x2="1310" y2="255" />
          <line className="line_sm" x1="1330" y1="152.89" x2="1330" y2="255" />
          <line className="line_sm" x1="1350" y1="151.06" x2="1350" y2="255" />
          <line className="line_sm" x1="1370" y1="147.29" x2="1370" y2="255" />
          <line className="line_sm" x1="1390" y1="146.61" x2="1390" y2="255" />
          <line className="line_sm" x1="1410" y1="145.08" x2="1410" y2="255" />
          <line className="line_sm" x1="1430" y1="143.49" x2="1430" y2="255" />
        </LineSm>
      </pattern>

      <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-footer)"></rect>
    </StyledSvg>
  );
};

// Define styles
const LineLg = styled.g`
  fill: none;
  stroke: #d2d2d2;
  stroke-width: 1;
  stroke-miterlimit: 10;
`;
const LineSm = styled.g`
  fill: none;
  stroke: #777777;
  stroke-width: 2;
  stroke-miterlimit: 10;
`;
